import { useMediaQuery } from "@mui/material";

/**
 * A hook for implementing mobile first media queries using the same breakpoint spots as tailwind
 * @returns a list of booleans for various media queries that define whether you are less than, within, or greater than the breakpoint
 */
export const useTailwindMediaQueries = () => {
    const minw_sm = useMediaQuery('(min-width:640px)');
    const minw_md = useMediaQuery('(min-width:768px)');
    const minw_lg = useMediaQuery('(min-width:1024px)');
    const minw_xl = useMediaQuery('(min-width:1280px)');
    const minw_2xl = useMediaQuery('(min-width:1536px)');

    const in_xs = !minw_sm;
    const in_sm = minw_sm && !minw_md;
    const in_md = minw_md && !minw_lg;
    const in_lg = minw_lg && !minw_xl;
    const in_xl = minw_xl && !minw_2xl;
    const in_2xl = minw_2xl;

    const maxw_xs = in_xs && !minw_sm;
    const maxw_sm = (in_xs || in_sm) && !minw_md;
    const maxw_md = (in_xs || in_sm || in_md) && !minw_lg;
    const maxw_lg = (in_xs || in_sm || in_md || in_lg) && !minw_xl;
    const maxw_xl = (in_xs || in_sm || in_md || in_lg || in_xl) && !minw_2xl;

    const phone = maxw_sm;
    const tablet = in_md || in_lg;
    const desktop = minw_xl;

    return {
        /** 640px - (infinity) */
        minw_sm,

        /** 768px - (infinity) */
        minw_md,

        /** 1024px - (infinity) */
        minw_lg,

        /** 1280px - (infinity) */
        minw_xl,

        /** 1536px - (infinity) */
        minw_2xl,
        
        /** 0px - (640px) */
        in_xs,

        /** 640px - (768px) */
        in_sm,

        /** 768px - (1024px) */
        in_md,

        /** 1024px - (1280px) */
        in_lg,

        /** 1280px - (1536px) */
        in_xl,

        /** 1536px - (infinity) */
        in_2xl,

        /** 0px - (640px) */
        maxw_xs,

        /** 0px - (768px) */
        maxw_sm,

        /** 0px - (1024px) */
        maxw_md,

        /** 0px - (1280px) */
        maxw_lg,

        /** 0px - (1536px) */
        maxw_xl,

        /** 0px - (768px) */
        phone,

        /** 768px - (1280px) */
        tablet,

        /** 1280px - (infinity) */
        desktop
    }
}


